import { atomFamily } from "recoil";

export const expandableCardAtomFamily = atomFamily({
	key: "expandableCardAtomFamily",
	default: {
		active: false,
	},
});
